export interface ParsedUploadError {
  code: string
  message: string
}

interface CodedError {
  code?: string
  message?: string
}

interface UploadErrorBody {
  errors?: { null?: CodedError } & Record<string, CodedError>
  errors_with_codes?: CodedError[]
}

interface UploadErrorResponse {
  data?: UploadErrorBody
}

const isUsable = (error: CodedError | undefined): error is ParsedUploadError =>
  !!error?.code &&
  !!error?.message &&
  error.code !== 'UNDEFINED' &&
  error.message !== 'UNDEFINED'

export const parseUploadError = (
  rawResponse: unknown
): ParsedUploadError | null => {
  const body = (rawResponse as UploadErrorResponse | undefined)?.data
  if (!body) return null

  if (isUsable(body.errors?.null)) return body.errors.null

  const fromCodes = body.errors_with_codes?.find(isUsable)
  if (fromCodes) return fromCodes

  return null
}
